var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image",
      class: { "icon-loading": !_vm.loaded },
      attrs: { "data-src": _vm.src }
    },
    [
      _vm.imageLoaded && _vm.isSupportedImage
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loaded,
                      expression: "loaded"
                    }
                  ],
                  staticClass: "image__main",
                  attrs: { src: _vm.src },
                  on: { load: _vm.onLoaded }
                })
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loaded,
                        expression: "loaded"
                      }
                    ],
                    staticClass: "image__caption"
                  },
                  [
                    _c("input", {
                      ref: "altInput",
                      attrs: { type: "text" },
                      domProps: { value: _vm.alt },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.updateAlt()
                        }
                      }
                    })
                  ]
                )
              ])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "image__placeholder" },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loaded,
                        expression: "loaded"
                      }
                    ],
                    staticClass: "image__main"
                  },
                  [
                    _c("div", {
                      staticClass: "icon-image",
                      style: _vm.mimeIcon
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.internalLinkOrImage,
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.isSupportedImage
                                ? _vm.t("text", "Show image")
                                : _vm.t("text", "Show file")
                            )
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]),
              _c("transition", { attrs: { name: "fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loaded,
                        expression: "loaded"
                      }
                    ],
                    staticClass: "image__caption"
                  },
                  [
                    _c("input", {
                      ref: "altInput",
                      attrs: { type: "text" },
                      domProps: { value: _vm.alt },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.updateAlt()
                        }
                      }
                    })
                  ]
                )
              ])
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }